import React, { useMemo, useEffect, useState } from 'react';
import PageTitle from '../layouts/PageTitle';
import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
import { useGetWorkLocationList } from "../../actions/worklocation-action";
import { ColumnFilter } from '../components/table/FilteringTable/ColumnFilter';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../components/table/FilteringTable/filtering.css';
import DataTable from '../pages/commonPages/DataTable';
import { deleteConfirmation } from '../../utils/ComponentUtilse';
import { useWorkLocationDeleteById } from '../../actions/worklocation-action';
import CustomTooltip from '../../utils/CommonUtils';


export const WorklocationListView = () => {

    const navigate = useNavigate();

    const [data, setData] = useState([])

    const { data: getAllWorkLocation, isLoading: loadingWorklocationFn, refetch: refetchWorklocation } = useGetWorkLocationList()

    const { mutate: deleteWorkLocationInfo, isLoading: loadingdeleteWorkLocationFn } = useWorkLocationDeleteById();

    useEffect(() => {
        if (getAllWorkLocation) {
            setData(getAllWorkLocation);
        }
    }, [getAllWorkLocation]);

    const columns = useMemo(
        () => [
            {
                Header: "Location Name",
                Footer: "Location Name",
                accessor: "location_name",
                Filter: ColumnFilter,
                className: "minWidth200",
            },
            {
                Header: "Location Code",
                Footer: "Location Code",
                accessor: "location_code",
                Filter: ColumnFilter,
                className: "minWidth100",
            },
            {
                Header: "Description",
                Footer: "Description",
                accessor: "description",
                Filter: ColumnFilter,
                className: "minWidth200",
            },

            {
                Header: "Action",
                Footer: "Action",
                accessor: "action",
                Filter: ColumnFilter,
                disableFilters: true,
                className: "minWidth100",
                Cell: ({ row }) => (
                    <>
                        <CustomTooltip id={`delete-${row.index}`} message="Delete">
                            <Button
                                className="shadow btn-xs sharp me-1"
                                variant="danger light"
                                style={{ cursor: "pointer" }}
                                onClick={() => deleteConfirmation(row.original.id, `Location - ${row.original.location_name}`, deleteWorkLocationInfo, refetchWorklocation)}
                            >
                                <i className="fa fa-trash"></i>
                            </Button>
                        </CustomTooltip>&nbsp;
                        <CustomTooltip id={`edit-${row.index}`} message="Edit">
                            <Button className="shadow btn-xs sharp me-1" variant='primary light' style={{ cursor: "pointer" }} onClick={() => handleEdit(row.original.id)}><i className="fas fa-pencil-alt"></i></Button>
                        </CustomTooltip>

                    </>
                ),

            },
        ],
        []
    );


    const handleEdit = (id) => {
        navigate('/add-worklocation/', { state: { rowId: id } })
    }
    const tableInstance = useTable({
        columns,
        data,
        initialState: { pageIndex: 0 }
    }, useFilters, useGlobalFilter, usePagination)

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        state,
        page,
        gotoPage,
        pageCount,
        pageOptions,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
    } = tableInstance

    const { pageIndex } = state


    return (
        <>
            <PageTitle activeMenu="Work Location" motherMenu="Settings" />
            <div className="card">
                <div className="card-header">
                    <h4 className="card-title"><i class="fa fa-users" aria-hidden="true"></i> Work Location</h4>
                    <div className="d-inline-flex">
                        <Link to={`/add-worklocation/`}>
                            <Button className='me-2' variant='primary btn-sm'>
                                <i class="fa fa-plus" aria-hidden="true"></i> &nbsp; Work Location
                            </Button>
                        </Link>

                    </div>
                </div>
                <div className="card-body">
                    <DataTable
                        isLoading={loadingWorklocationFn}
                        columns={columns}
                        tableInstance={tableInstance}
                    />

                </div>
            </div>
        </>
    )

}
export default WorklocationListView;